import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-dropdown", async () => {
    it("passes the regression test closed", async () => {
        await regressionTest({
            storyId: getTestStory("dropdown", "dropdown"),
            componentTag: "ux-dropdown",
            pageHeight: 180,
            pageWidth: 500,
        });
    });

    it("passes the regression test open", async () => {
        await regressionTest({
            storyId: getTestStory("dropdown", "filterable-dropdown"),
            componentTag: "ux-dropdown",
            pageHeight: 340,
            pageWidth: 500,
            performActions: async (page) => {
                await page.click("ux-dropdown");
                await page.waitForTimeout(1000);
            },
        });
    });

    it("passes the regression test one choice", async () => {
        await regressionTest({
            storyId: getTestStory(
                "dropdown",
                "one-choice-dropdown-with-placeholder"
            ),
            pageHeight: 340,
            pageWidth: 500,
            componentTag: "ux-dropdown",
            performActions: async (page) => {
                await page.click("ux-dropdown");
                await page.waitForTimeout(1000);
            },
        });
    });
});
